import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import MemberSectionPanel from "../../shared/component/MemberSectionPanel";
import MyPreviousOrdersColumn from "../../shared/component/dataTable/columns/MyPreviousOrdersColumn.json";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Loading from "../../shared/component/others/Loading";
import Dialog from "../../shared/component/dialog/Dialog";
import ItemsDetail from "../storemanagement/ItemsDetail";
import DataTableMember from "../../shared/component/dataTable/DataTableMember";
import "./myOrders.css";

export default class MyOrders extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            displayDialog: false
        };
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="my-orders-page">
                <AvForm>
                    {this.ordersList()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    };

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => {
            ref.setData(Object.assign({}, data));
        });
    };

    ordersList() {
        return (
            <div className="p-col-12">
                <MemberSectionPanel title="My Orders" sectionId="my-orders" collapsible defaultOpen>
                    <DataTableMember
                        ref={(elem) => {
                            this.refDataTable = elem;
                        }}
                        fields={MyPreviousOrdersColumn.fields}
                        objectName={MyPreviousOrdersColumn.name}
                        dataURL="dispatchio/basket/previousorders"
                        emptyMessage="No orders yet"
                        responsive={false}
                        paginator={true}
                        onDataSelect={this.onDataSelect}
                        selectionMode="single"
                        loading={this.state.loading}
                    />

                    <Dialog
                        className="order-detail-dialog"
                        visible={this.state.displayDialog}
                        header="Order Details"
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleForReportDialogDetail()}
                    >
                        <ItemsDetail
                            closeDisplayDialog={this.closeDisplayDialog}
                            ref={(elem) => {
                                this.refModelSave = elem;
                            }}
                        />
                    </Dialog>
                </MemberSectionPanel>
            </div>
        );
    }
}
